import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { IN_BOX_KIT_COLORS, IN_BOX_OPTIONS, type InBoxCompleteness } from '../utils/inBoxCompleteness'
import SelectionPickerGrid from './SelectionPickerGrid'

const BUILDER_KIT_ART: Record<InBoxCompleteness, string> = {
  full: '/images/sell/komplektacija/pilna.png?v=1',
  partial: '/images/sell/komplektacija/daline.png?v=1',
  phone_only: '/images/sell/komplektacija/tik-telefonas.png?v=1',
}

interface InBoxPickerGridProps {
  value: InBoxCompleteness | null
  onChange: (value: InBoxCompleteness) => void
  /** Desktop sell builder — 3 illustrated cards (same language as Būklė). */
  builderDesktop?: boolean
}

export default function InBoxPickerGrid({
  value,
  onChange,
  builderDesktop = false,
}: InBoxPickerGridProps) {
  const { t } = useTranslation()
  const options = useMemo(
    () =>
      IN_BOX_OPTIONS.map((kit) => {
        const labelKey = kit === 'phone_only' ? 'phoneOnly' : kit
        return {
          value: kit,
          color: IN_BOX_KIT_COLORS[kit],
          title: t(`listing.kit.${labelKey}`),
          hint: t(`listing.kit.${labelKey}Hint`),
          ...(builderDesktop
            ? {
                imageSrc: BUILDER_KIT_ART[kit],
                imageAlt: t(`listing.kit.${labelKey}`),
              }
            : {}),
        }
      }),
    [t, builderDesktop],
  )

  return (
    <SelectionPickerGrid
      options={options}
      value={value}
      onChange={(next) => onChange(next as InBoxCompleteness)}
      ariaLabel={t('listing.kitLegend')}
      stack={!builderDesktop}
    />
  )
}
